export const EthereumIcon = () => (
  <svg viewBox='0 0 32 32' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path d='M7 16.8392L15.5 3L24 16.8392L15.5 21.9271L7 16.8392Z' fill='currentColor' />
    <path d='M15.5 30L7 18.2638L15.5 23.4196L24 18.2638L15.5 30Z' fill='currentColor' />
  </svg>
)
